import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import marked from 'marked';

/**
 * Component displaying single toggleable FAQ entry
 */
var FaqEntryComponent = /** @class */ (function (_super) {
    __extends(FaqEntryComponent, _super);
    function FaqEntryComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FaqEntryComponent.prototype, "answerHtml", {
        get: function () {
            return marked(this.answer || '');
        },
        enumerable: false,
        configurable: true
    });
    FaqEntryComponent.prototype.onToggle = function (event) {
        return event.detail[0];
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], FaqEntryComponent.prototype, "question", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], FaqEntryComponent.prototype, "answer", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], FaqEntryComponent.prototype, "initiallyVisible", void 0);
    __decorate([
        Emit('toggle'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], FaqEntryComponent.prototype, "onToggle", null);
    FaqEntryComponent = __decorate([
        Component({
            name: 'faq-entry',
        })
    ], FaqEntryComponent);
    return FaqEntryComponent;
}(Mixins(MagicConfigMixin)));

export default FaqEntryComponent;
